import axios from 'axios'
import qs from 'qs'
import config from './config'
import { captureException } from './utils/util'
const bbsHost = process.server ? config.listURL : '/bbs'
const service = axios.create({
  baseURL: bbsHost,
  timeout: 8000
})

const wwwHost = process.server ? config.wwwURL : '/official/api'
const wwwService = axios.create({
  baseURL: wwwHost,
  timeout: 8000,
  transformRequest: [function (data) {
    data = qs.stringify(data)
    return data
  }],
  headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' }
})

const testSerice = axios.create({
  timeout: 8000,
  transformRequest: [function (data) {
    data = qs.stringify(data)
    return data
  }],
  headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' }
})

const nodeHostUrl = process.server ? config.nodeURL : '/node-host'
const nodeHostService = axios.create({
  baseURL: nodeHostUrl,
  timeout: 8000,
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
})

// 每个实例的拦截器
nodeHostService.interceptors.response.use(function (config) {
  return config
}, function (error) {
  captureException(error)
  return Promise.reject(error)
})
testSerice.interceptors.response.use(function (config) {
  return config
}, function (error) {
  captureException(error)
  return Promise.reject(error)
})
wwwService.interceptors.response.use(function (config) {
  return config
}, function (error) {
  captureException(error)
  return Promise.reject(error)
})
axios.interceptors.response.use(function (config) {
  return config
}, function (error) {
  captureException(error)
  return Promise.reject(error)
})
service.interceptors.response.use(function (config) {
  return config
}, function (error) {
  captureException(error)
  return Promise.reject(error)
})

export default {
  postTestAxios (url, params) {
    return testSerice.post(
      url,
      params
    )
  },
  getNewsList (params) {
    return service({
      method: 'post',
      url: '/info/infos',
      params: params
    })
  },
  getNewsDetail (params) {
    return service({
      method: 'post',
      url: '/info/info',
      params: params
    })
  },

  //   postLessonForm (apiUrl, params) {
  //     return wwwService.post(
  //       apiUrl,
  //       params
  //     )
  //   },
  postLessonForm (apiUrl = '/open/api/market-web-server/v1/registration/appointment', params) {
    // 为了兼容老数据这里做统一处理
    if (params) {
      const map = {
        grade: 'stuGrade',
        channel_code: 'code',
        channel_keyword: 'key'
      }

      for (const key in params) {
        if (key in map) {
          params[map[key]] = params[key]
          delete params[key]
        }
      }
    }
    return axios.post(
      apiUrl,
      params
    )
  },
  getPlatformOnOffStatus (params) {
    return axios({
      method: 'get',
      url: '/opGateway/api/operation-web-server/v1/user/sem-channel-switch',
      params
    })
  },
  sendVerifier (params) {
    return axios.post(
      '/opGateway/api/market-web-server/v1/registration/sendSms',
      params
    )
  },
  sendVerifierNew (params) {
    return axios.post(
      '/opGateway/api/market-web-server/v1/registration/sendSms',
      params
    )
  },
  validateNew (params) {
    return axios.post(
      '/opGateway/api/market-web-server/v1/registration/checkCode',
      params
    )
  },
  hasTag (params) {
    return wwwService({
      method: 'get',
      url: '/student/has-tag',
      params: params
    })
  },

  // 预约排练
  postLessonFormPeilian (params) {
    return wwwService.post(
      '/student/register-peilian',
      params
    )
  },

  // 是否预约过陪练
  postLessonHasPeilian (params) {
    return wwwService({
      method: 'get',
      url: '/student/has-register-peilian',
      params: params
    })
  },
  getQrcode () {
    return wwwService.post(
      '/qrcode/find-visible-mobile-api'
    )
  },
  getPvNum (params) {
    return wwwService.post(
      '/user/get-statistic-pv',
      params
    )
  },
  makeCall (params) {
    return wwwService.post(
      '/call-center/make-direct-call',
      params
    )
  },
  registerStep1 (data) {
    return wwwService({
      method: 'post',
      url: '/student/register-and-book-by-step',
      data
    })
  },
  registerStep2 (data) {
    return wwwService({
      method: 'post',
      url: '/student/register-and-book-by-step',
      data
    })
  },
  getUrlDownload (data) {
    return wwwService({
      method: 'post',
      url: '/user/get-app-url',
      data
    })
  },
  getSubjectData () {
    return nodeHostService({
      method: 'post',
      url: '/api/v1/getGradeSubject'
    })
  },
  ocpcTrack (data) {
    return nodeHostService({
      method: 'post',
      url: '/api/v1/ocpcTrack',
      data
    })
  },

  // 我们自己的统计
  statisticsCount (data) {
    return nodeHostService({
      method: 'post',
      url: '/api/statistics/count',
      data
    })
  },

  // 统计
  zmtongji (data) {
    return axios({
      method: 'post',
      url: '/log/official',
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      },
      data
    })
  },

  // 查询学生是否绑定销售
  querySellerByStuMobile (data) {
    return axios({
      method: 'post',
      url: '/opGateway/api/operation-mobile-web/v1/org/student/querySellerByStuMobile',
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      },
      data
    })
  }
}
